import {useSearchParam} from 'react-use';
import React from 'react';
import {TourInvalidLinkDialog} from '../../modules/tourPlayer/components/TourInvalidLinkDialog';
import graphql from 'babel-plugin-relay/macro';
import {useQuery} from 'relay-hooks';
import {FullscreenLoader} from '../../components/loader/FullscreenLoader';
import {TourErrorDialog} from '../../modules/tourPlayer/components/TourErrorDialog';
import {TourNotFoundMessage} from '../../modules/tourPlayer/components/TourNotFoundMessage';
import {AgentTour} from '../../modules/tourPlayer/tourPlayerPreview/components/AgentTour';
import {AgentTourPageQuery} from '../../__generated__/AgentTourPageQuery.graphql';
const query = graphql`
  query AgentTourPageQuery($tourID: ID!) {
    tour: node(id: $tourID) {
      ...AgentTour_tour
    }
  }
`;

export const AGENT_TOUR_CONTAINER_ID = 'agentTourContainer';
function AgentTourPageComponent({tourID}: {tourID: string}) {
  const {data, isLoading, error} = useQuery<AgentTourPageQuery>(
    query,
    {tourID},
    {
      fetchPolicy: 'network-only',
      networkCacheConfig: undefined,
    }
  );

  if (isLoading) {
    return (
      <div
        style={{
          backgroundColor: '#758089',
          height: '100svh',
        }}
      >
        <FullscreenLoader />
      </div>
    );
  }

  if (error != null) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return <TourErrorDialog isOpen onClose={() => {}} />;
  }

  if (data?.tour == null) {
    return <TourNotFoundMessage />;
  }

  return <AgentTour tourRef={data.tour} />;
}

export function AgentTourPage() {
  const tourID = useSearchParam('tourId');

  if (tourID == null) {
    return <TourInvalidLinkDialog />;
  }

  return <AgentTourPageComponent tourID={tourID} />;
}
